import styled from '@emotion/styled/macro';
import { Variables } from '../../../base/variables';
import * as Shared from '../form.styles';

export const FormContainer = Shared.FormContainer;
export const FormGrid = Shared.FormGrid;
export const FormField = Shared.FormField;
export const Label = Shared.Label;
export const Input = Shared.Input;
export const Select = Shared.Select;
export const ErrorMessage = Shared.ErrorMessage;
export const AutocompleteContainer = Shared.AutocompleteContainer;
export const AutocompleteDropdown = Shared.AutocompleteDropdown;
export const AutocompleteOption = Shared.AutocompleteOption;
export const LoadingText = Shared.LoadingText;
export const NoResults = Shared.NoResults;

export const SavingIndicator = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background-color: ${Variables.Colors.n15_24};
    border-radius: 4px;
    font-size: 12px;
    color: ${Variables.Colors.n70};
`;

